import React, { CSSProperties } from 'react';
import { FaArrowUpRightFromSquare } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import PDFSVG from '../assets/icons/pdfIcon.svg';
import { flexCenter } from '../style/reusableStyle';

const PlaceholderStyled = styled.div`
  width: fit-content;
  position: relative;
  height: 140px;
  width: 110px;
  cursor: pointer;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  background-color: #f0f0f0;

  & .link {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    ${flexCenter(0)};
  }

  & .pdf-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  & .open-icon {
    position: absolute;
    top: 6px;
    left: 6px;
  }
`;

type Props = {
  link: string;
  style?: CSSProperties;
};

const PDFPlaceholder = ({ link, style = {} }: Props) => {
  return (
    <PlaceholderStyled style={style}>
      <Link className="link" to={link} target="_blank">
        <img src={PDFSVG} alt="pdf icon" className="pdf-img" />
        <FaArrowUpRightFromSquare
          size={15}
          color="dimgray"
          className="open-icon"
        />
      </Link>
    </PlaceholderStyled>
  );
};

export default PDFPlaceholder;
